export default __webpack_public_path__ + "static/media/promo-issue-no-1_00.091e20cc.jpg";